import React from 'react';
import { useCurrentEditor } from '@tiptap/react';

import cn from '../../../../Utils/cn';

export interface MenuButtonProps {
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isActive?: boolean;
  disabled?: boolean;
  disabledHoverEffect?: boolean;
  /** Names a button that shows only an icon. */
  'aria-label'?: string;
  /** For a button that opens a popover: the props `usePopoverState` returns as `triggerProps`. */
  'aria-haspopup'?: 'dialog';
  'aria-expanded'?: boolean;
  'aria-controls'?: string;
}

const ToolbarButton: React.FC<React.PropsWithChildren<MenuButtonProps>> = ({
  className,
  onClick,
  isActive,
  disabled,
  disabledHoverEffect,
  children,
  ...ariaProps
}) => {
  const { editor } = useCurrentEditor();
  const disableButton = !editor?.isEditable || disabled;

  return (
    <button
      className={cn(
        'm-4 inline-flex items-center rounded border-0 bg-transparent',
        {
          'bg-slate-400': isActive && !disableButton,
          'opacity-50': disableButton,
          'hover:bg-slate-400 hover:bg-opacity-50': !disabledHoverEffect && !disableButton,
          'cursor-pointer': !disableButton,
        },
        className
      )}
      onClick={onClick}
      disabled={disableButton}
      {...ariaProps}
    >
      {children}
    </button>
  );
};

export default ToolbarButton;
